import React, { useState } from "react";
import JoLedger from "../accounting/JoLedger";

const SuperAdminJoLedger = () => {
  const [scopeMode, setScopeMode] = useState("all");

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-3 rounded-3xl border border-white/70 bg-white/90 p-4 shadow-sm sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
            Scope Filter
          </p>
          <h2 className="text-lg font-bold text-blue">JO Ledger Access</h2>
          <p className="text-sm text-gray-500">
            Switch between your own JO and all JO across employees.
          </p>
        </div>

        <div className="inline-flex rounded-2xl border border-gray-200 bg-gray-50 p-1">
          <button
            type="button"
            onClick={() => setScopeMode("created")}
            className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${
              scopeMode === "created"
                ? "bg-blue text-white shadow-sm"
                : "text-gray-600 hover:text-blue"
            }`}
          >
            Own JO
          </button>
          <button
            type="button"
            onClick={() => setScopeMode("all")}
            className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${
              scopeMode === "all"
                ? "bg-blue text-white shadow-sm"
                : "text-gray-600 hover:text-blue"
            }`}
          >
            All JO
          </button>
        </div>
      </div>

      <JoLedger
        portalLabel="Super Admin Portal"
        pageTitle="JO Ledger"
        pageDescription="Consolidated financial view per Job Order. Use Own JO to focus on your created records or All JO to review every employee's activity."
        scope={scopeMode}
        basePath="/superAdmin/jo-ledger"
      />
    </div>
  );
};

export default SuperAdminJoLedger;
